import * as yup from "yup";
import { TipoCupom } from "../../pedidos/enum/TipoCupom";
import { TipoMarketplace } from "../../marketplace/enum/TipoMarketplace";

export const cupomSchema = yup.object().shape({
  codigo: yup.string().required("O código é obrigatório").max(50, "O código não pode ter mais que 50 caracteres"),
  nome: yup.string().required("O nome é obrigatório").max(100, "O nome não pode ter mais que 100 caracteres"),
  descricao: yup.string().required("A descrição é obrigatória").max(500, "A descrição não pode ter mais que 500 caracteres"),
  tipo: yup.string().oneOf(Object.values(TipoCupom).filter(tipo => tipo !== TipoCupom.ITEM_DESCONTO_PROGRESSIVO && tipo !== TipoCupom.ITEM), "Tipo de cupom inválido").required("O tipo é obrigatório"),
  valor: yup.number().when("tipo", {
    is: TipoCupom.TAXA_ENTREGA,
    then: (schema) => schema.nullable(),
    otherwise: (schema) => schema.required("O valor é obrigatório").min(0.01, "O valor deve ser maior que zero")
  }),
  dataValidade: yup.string().nullable().test('data-futura', 'A data de validade deve ser futura', function(value) {
    if (!value) return true; // Campo opcional
    const dataValidade = new Date(value);
    const hoje = new Date();
    // Compara apenas a data, ignorando a hora
    hoje.setHours(0, 0, 0, 0);
    dataValidade.setHours(0, 0, 0, 0);
    return dataValidade >= hoje;
  }),
  limiteUsoPorUsuario: yup.number()
    .transform((value, originalValue) => {
      if (originalValue === "" || originalValue === null || originalValue === undefined) {
        return null;
      }
      return value;
    })
    .nullable()
    .integer("O limite deve ser um número inteiro")
    .min(1, "O limite deve ser maior que zero"),
  ativo: yup.boolean().nullable(),
  marketplaces: yup.array().of(
    yup.object().shape({
      uuid: yup.string().nullable(),
      tipo: yup.string().oneOf(Object.values(TipoMarketplace), "Tipo de marketplace inválido").required("O tipo é obrigatório")
    })
  ).nullable()
});
